import { render } from "./InstantTransfer.vue?vue&type=template&id=bbac0180&scoped=true"
import script from "./InstantTransfer.vue?vue&type=script&lang=js"
export * from "./InstantTransfer.vue?vue&type=script&lang=js"

import "./InstantTransfer.vue?vue&type=style&index=0&id=bbac0180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbac0180"]])

export default __exports__